import { c as _c } from "react/compiler-runtime";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setVippsAgreement } from "../../../../../store/donation/actions";
import { State } from "../../../../../store/state";
import { ToolTip } from "../../../../shared/ToolTip/ToolTip";
import { CustomCheckBox } from "../../../DonorPane/CustomCheckBox";
import { CheckBoxWrapper, HiddenCheckBox } from "../../../Forms.style";
import { DateBoxWrapper, DateText, DateTextWrapper, Wrapper } from "./VippsDatePicker.style";
import { formatDateText, getNextChargeDate, isIrregularChargeDay, showCheckBox } from "./dates";
import { DatePicker } from "../../../../shared/DatePicker/DatePicker";
import { DatePickerInputConfiguration } from "../../../../../../DatePicker/DatePickerInput";
import { Dispatch } from "@reduxjs/toolkit";
import { DonationActionTypes } from "../../../../../store/donation/types";
const tooltipText = "Vi kan av tekniske grunner ikke melde trekk 1-3 dager i forveien, så første trekkdato utsettes med én måned. Du kan velge en senere dato eller krysse av for også å bli trukket i dag.";
export const VippsDatePicker: React.FC<{
  config: DatePickerInputConfiguration;
}> = t0 => {
  const $ = _c(34);
  const {
    config
  } = t0;
  const dispatch = useDispatch();
  const vippsAgreement = useSelector(_temp);
  const [selectedChargeDay, setSelectedChargeDay] = useState(vippsAgreement.monthlyChargeDay);
  const [nextChargeDate, setNextChargeDate] = useState();
  const [initialCharge, setinitialCharge] = useState(true);
  let t1;
  if ($[0] !== dispatch || $[1] !== initialCharge || $[2] !== selectedChargeDay || $[3] !== vippsAgreement) {
    t1 = () => {
      setNextChargeDate(getNextChargeDate(selectedChargeDay, initialCharge));
      dispatch(setVippsAgreement({
        ...vippsAgreement,
        monthlyChargeDay: selectedChargeDay,
        initialCharge
      }));
    };
    $[0] = dispatch;
    $[1] = initialCharge;
    $[2] = selectedChargeDay;
    $[3] = vippsAgreement;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== initialCharge || $[6] !== selectedChargeDay) {
    t2 = [selectedChargeDay, initialCharge];
    $[5] = initialCharge;
    $[6] = selectedChargeDay;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  useEffect(t1, t2);
  const t3 = vippsAgreement.initialCharge && `Første trekk blir i dag, deretter den ${selectedChargeDay === 0 ? "siste" : `${selectedChargeDay}.`} hver måned `;
  const t4 = !vippsAgreement.initialCharge && nextChargeDate && "F\xF8rste trekk blir ";
  let t5;
  if ($[8] !== nextChargeDate || $[9] !== selectedChargeDay || $[10] !== vippsAgreement.initialCharge) {
    t5 = !vippsAgreement.initialCharge && isIrregularChargeDay(selectedChargeDay) ? nextChargeDate && <strong>{`${formatDateText(nextChargeDate)} `}</strong> : !vippsAgreement.initialCharge && nextChargeDate && `${formatDateText(nextChargeDate)} `;
    $[8] = nextChargeDate;
    $[9] = selectedChargeDay;
    $[10] = vippsAgreement.initialCharge;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== t3 || $[13] !== t4 || $[14] !== t5) {
    t6 = <DateText>{t3}{t4}{t5}</DateText>;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== selectedChargeDay) {
    t7 = isIrregularChargeDay(selectedChargeDay) && <ToolTip text={tooltipText} />;
    $[16] = selectedChargeDay;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t6 || $[19] !== t7) {
    t8 = <div>{t6}{t7}</div>;
    $[18] = t6;
    $[19] = t7;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== initialCharge || $[22] !== selectedChargeDay) {
    t9 = showCheckBox(selectedChargeDay) && <CheckBoxWrapper><HiddenCheckBox name="initialCharge" type="checkbox" onChange={() => {
        (document.activeElement as HTMLElement).blur();
        setinitialCharge(!initialCharge);
      }} onKeyDown={e => {
        if (e.key === "Enter" || e.key === " ") {
          setinitialCharge(!initialCharge);
          e.preventDefault();
        }
      }} /><CustomCheckBox label={"Trekk meg for denne m\xE5neden ogs\xE5"} checked={initialCharge} /></CheckBoxWrapper>;
    $[21] = initialCharge;
    $[22] = selectedChargeDay;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== t8 || $[25] !== t9) {
    t10 = <DateTextWrapper>{t8}{t9}</DateTextWrapper>;
    $[24] = t8;
    $[25] = t9;
    $[26] = t10;
  } else {
    t10 = $[26];
  }
  const t11 = vippsAgreement?.monthlyChargeDay;
  let t12;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = date => {
      if (!showCheckBox(date)) {
        setinitialCharge(false);
      }
      setSelectedChargeDay(date);
    };
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== config || $[29] !== t11) {
    t13 = <DateBoxWrapper><DatePicker selected={t11} onClickOutside={_temp2} onChange={t12} configuration={config} /></DateBoxWrapper>;
    $[28] = config;
    $[29] = t11;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t10 || $[32] !== t13) {
    t14 = <Wrapper>{t10}{t13}</Wrapper>;
    $[31] = t10;
    $[32] = t13;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};
function _temp(state) {
  return state.donation.vippsAgreement;
}
function _temp2() {}